<template>
    <div class="register">
            <div class="main">
                <div class="mainBox">
                  <div class="title">新用户注册</div>
                  <p>请选择用户身份：</p>
                  <div class="userTab">
                    <div class="item" :style='{backgroundImage:"url("+studentBlue+")"}' v-if="userType==1">
                      <span style="color:#fff ">学生</span>
                    </div>
                    <div class="item" :style='{backgroundImage:"url("+parentWhite+")"}' v-if="userType==1" @click="userType=2">
                      <span style="color: #3D90F6">家长</span>
                    </div>
                    <div class="item" :style='{backgroundImage:"url("+studentWhite+")"}' v-if="userType==2" @click="userType=1">
                      <span style="color:#3D90F6">学生</span>
                    </div>
                    <div class="item" :style='{backgroundImage:"url("+parentBlue+")"}' v-if="userType==2">
                      <span style="color:#fff">家长</span>
                    </div>
                  </div>
                  <div class="inputs" style="margin-bottom:16px">                   
                    <input type="text" v-model="Username" placeholder="请输入手机号">
                  </div>
                  <div class="inputs verification" style="margin-bottom:16px">
                    <sms-verification 
                        :phone="Username"
                        :key-code.sync="KeyCode"
                        :is-show-key-code="isShowKeyCode"
                        :time="time"
                        @sendCode="getKeyCode"
                    />
                  </div>
                  <div class="inputs pw" style="margin-bottom:16px">
                    <input  type="password" v-model="Password" autocomplete="off" placeholder="请输入密码">
                  </div>
                  <div class="inputs" style="margin-bottom:0px" >
                    <input  type="password" v-model="Password1" autocomplete="off"   placeholder="确认密码" >
                  </div>
                  <!-- <p class="warning4">{{warning4}}</p> -->
                  <div class="button" @click="this.Submission" v-show="isShowBtn">立即注册</div>
                  <div class="btn_disabled" v-show="!isShowBtn">立即注册</div>
                  <div class="bottom" >
                      已有账号，<span @click="$router.push('/login')">去登录</span>
                  </div>
                </div>
                
            </div>
    </div>
</template>
<script>
import { Message } from 'element-ui';
import SmsVerification from '@/components/SmsVerification.vue';
import { generateSmsCode } from '@/utils/security';

    export default {       
        name: "register",
        components: {
            SmsVerification
        },
        metaInfo () {
            return {
                title: this.Pctitle,
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: this.copyright ? this.copyright.keywords : '',
                }],
                link: [{                 // set link
                    rel: 'icon',
                    href: this.copyright ? this.copyright.mark : ''
                }]
            }
        },  
        data() {
            return {
                isShowBtn:true,
                ShowBtn_time:60,
                Username: '',
                KeyCode: '',
                Password: '',
                Password1: '',
                warning4: '',
                isclick: false,
                time: 60,
                isShowKeyCode: true,
                success:false,
                userType:1,
                studentBlue:'/imgs/user/student_blue.png',
                studentWhite:'/imgs/user/student_white.png',
                parentBlue:'/imgs/user/parent_blue.png',
                parentWhite:'/imgs/user/parent_white.png'
            }
        },
        watch:{
            Username() {
                this.panduan();
            },
            KeyCode() {
                this.panduan();
            },
            Password() {
                this.panduan();
            },
            Password1() {
                this.panduan();
            },
            // 勾选同意
            isChecked() {
                this.panduan();
            }
        },
        methods: {
          // 获取版权信息
          get_footer_copyright(){
                var OEMdomain = this.$OEMdomain=='localhost'?'http://39.98.37.134':this.$OEMdomain,
                _this = this;
                this.$ajax.post(this.G_uri + '/website/getConfigInfo', {
                    webSite: OEMdomain
                }).then(function(res){
                    if(res.data.code == 2000){
                        _this.copyright = res.data.data;
                        _this.Pctitle = res.data.data.title
                    }
                })
            }, 
            Submission() {
                this.btn_timers();
                var OEMdomain = this.$OEMdomain;
                var phone = this.Username;
                var code = this.KeyCode;
                var passwordOne = this.Password;
                var passwordTwo = this.Password1;
                var _this = this;
                var num1 = this.Username;
                var reg = /^1[123456789]\d{9}$/;
                var num2 = this.KeyCode;
                var reg3 = /[a-zA-z0-9!@#$%^&*.?]{6,20}/;
                var num3 = this.Password;
                var num4 = this.Password1;
                var userType = this.userType;
                // var num5 = this.isChecked;
                if(!num1) {
                    // console.log(99999999)
                    this.warning4 = '手机号码不能为空';
                    Message.error({
                        message: '手机号码不能为空,60s后重试',
                        type: 'error'
                    });
                    return;
                }
                if(!reg.test(num1)) {
                    this.warning4 = '账号或密码不正确';
                    Message.error({
                        message: '账号或密码不正确,60s后重试',
                        type: 'warning'
                    });
                    return;
                }
                if(!num2) {
                    this.warning4 = '验证码不能为空';
                    Message.error({
                        message: '验证码不能为空,60s后重试',
                        type: 'error'
                    });
                    return;
                }
                if(!num3) {
                    this.warning4 = '密码不能为空';
                    Message.error({
                        message: '密码不能为空,60s后重试',
                        type: 'error'
                    });
                    return;
                }
                if(!reg3.test(num3)) {
                    // 请设置6至20位登录密码
                    this.warning4 = '密码不能少于6位字符，不能超过20位字符';
                    Message.error({
                        message: '密码不能少于6位字符，不能超过20位字符,60s后重试',
                        type: 'error'
                    });
                    return;
                }
                if(num3 != num4) {
                    this.warning4 = '两次输入的密码不一致';
                    Message.error({
                        message: '两次输入的密码不一致,60s后重试',
                        type: 'error'
                    });
                    return;
                }
                if(!this.isclick) {
                    return;
                }
                this.$ajax.post(this.G_uri + this.ports.user.register, {
                    userType:userType,
                    phone: phone,
                    code: code,
                    passwordOne: passwordOne,
                    passwordTwo: passwordTwo,
                    webSite: OEMdomain
                })
                    .then((res)=> {
                        if(res.data.code == 2000) {
                          // console.log('注册成功')
                            window.sessionStorage.setItem('ymtxToken', res.data.data.token);
                            window.localStorage.setItem('ymtxLocalToken',res.data.data.token);
                            window.sessionStorage.setItem('lct_token', res.data.data.token);
                            if(userType==1) {
                              sessionStorage.setItem('userType','student')
                              window.localStorage.setItem('localUserType','student');
                              window.sessionStorage.setItem('ymtxUserMessage', true);
                              window.localStorage.setItem('localymtxUserMessage', true);
                              window.sessionStorage.setItem('token', res.data.data.token);
                              window.localStorage.setItem('localtoken', res.data.data.token);
                              this.$router.push('/perfectInformation');
                            } else if(userType==2) {
                              sessionStorage.setItem('userType','parent');
                              window.localStorage.setItem('localUserType','parent');
                              this.$router.push('/parent/home/ques');
                              this.$store.commit('getParentStatus',1);
                            }
                            _this.success=true
                        }else {
                            _this.warning4 = res.data.msg;
                            Message.error(res.data.msg)
                            
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            // 点击显示密码
            isshowpassword() {
                if(this.$refs.Password0.type === "password") {
                    this.$refs.Password0.type = "text"
                }else {
                    this.$refs.Password0.type = "password"
                }
            },
            panduan() {
                var num1 = this.Username;
                var num2 = this.KeyCode;
                var num3 = this.Password;
                var num4 = this.Password1;
                if(num1 && num2 && num3 && num4) {
                    this.isclick = true;
                }else {
                    this.isclick = false;
                }
            },
            timers() {
              var _this = this;
              this.isShowKeyCode = false;
                var timer = setInterval(function() {
                    _this.time --;
                    if(_this.time == 0) {
                        clearInterval(timer)
                        _this.isShowKeyCode = true;
                        _this.time = 60;
                    }
                }, 1000)
            },
            btn_timers() {
              var _this = this;
              this.isShowBtn = false;
                var timer = setInterval(function() {
                    _this.ShowBtn_time --;
                    if(_this.ShowBtn_time == 0) {
                        clearInterval(timer)
                        _this.isShowBtn = true;
                        _this.ShowBtn_time = 60;
                    }
                }, 1000)
            },
            getKeyCode() {
                var OEMdomain = this.$OEMdomain;
                var phone = this.Username;
                var reg = /(^1[123456789]\d{9}$)/;
                var _this = this;
                var userType = this.userType;
                if(!reg.test(phone)) {
                    this.warning4 = '请输入正确的手机号';
                    Message.error({
                        message: '请输入正确的手机号',
                        type: 'error'
                    });
                    return;
                }else {
                    this.warning4 = ""
                }
                if(!this.isShowKeyCode) {
                    return;
                }
                const { timestamp, code } = generateSmsCode();
                this.$ajax.post(this.G_uri + this.ports.user.getPhoneNumberByCode, {
                    userType: userType,
                    phone: phone,
                    webSite: OEMdomain,
                    code: code,
                    timestamp: timestamp
                }).then(function (res) {
                    if (res.data.code == 2000) {
                        _this.timers();
                    } else {
                        _this.warning4 = res.data.msg;
                        Message.error({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    console.log(error)
                });
            }
        },
        mounted(){
          this.get_footer_copyright();
        }
    }
</script>

<style scoped lang="less">
    .register{
      .main{
        width: 1200px;
        height: 680px;
        background: #fff;
        position: absolute;
        left:50%;
        top:50%;
        margin-left: -600px;
        margin-top: -340px;
        .mainBox{
           width: 530px;
           margin: 0 auto;
          .title{
            line-height: 28px;
            color: #333333;
            font-size: 24px;
            text-align: center;
            margin: 70px auto 46px;
            font-weight: bold;
          }
          p{
            font-size: 14px;
            font-weight: 400;
            color: #7C7C7C;
            line-height: 20px;
          }
          .userTab{
              margin:16px 0 30px;
              overflow: hidden;
             .item{
               width: 63px;
               height: 69px;
               float: left;
               margin-right: 20px;
               background-size: 100% 100%;
               cursor: pointer;
               span{
                 display: block;
                 margin-top:42px;
                 text-align: center;
               }
             }
          }
          .inputs{
            width: 100%;
            height: 42px;
            display: block;
            // border-bottom: 1px solid #979797;
            margin: 0 auto;
            line-height: 42px;
            color: #7C7C7C;
            position: relative;
            background: rgba(36, 130, 243, 0.1);
            border-radius: 4px;
            border: 1px solid rgba(25, 122, 239, 0.3);
            // &>img{
            //   position: relative;
            //   top:-1px;
            // }
            input{
              border: none;
              height: 42px;
              width: 414px;
              line-height: 52px;
              display: inline-block;
              // padding-left: 50px;
             background: none;
             border-radius: 4px;
             outline: none;
             text-indent: 24px;
            }
            input:-webkit-autofill {
               -webkit-box-shadow: none !important;
            }
            /deep/input:-internal-autofill-selected{
              appearance: menulist-button;
              background: none !important;
              background-image: none !important;
              color: #7C7C7C !important;
            }          
          }
          .inputs.verification{
            background: none;
            border: none;
            border-radius: 0px;
            > input{
              background: rgba(36, 130, 243, 0.1);
              border-radius: 4px;
              border: 1px solid rgba(25, 122, 239, 0.3);
            }
          }
          .getKeyCode{
            // width: 87px;
            // height: 28px;
            // border: 1px solid #3D90F6;
            // border-radius: 14px;
            text-align: center;
            // color: #3D90F6;
            font-size: 14px;
            line-height:42px;
            position: absolute;
            right: 0;
            top:0px;
            cursor: pointer;
            width: 104px;
            height: 42px;
            background: linear-gradient(270deg, #0B71EB 0%, #3D93FA 100%);
            border-radius: 4px;
            color: #fff;
            border: 1px solid rgba(25, 122, 239, 0.3)
          }
          .time{
            text-align: center;
            // color: #3D90F6;
            font-size: 14px;
            line-height:42px;
            position: absolute;
            right: 0;
            top:0px;
            cursor: pointer;
            width: 104px;
            height: 42px;
            background: #ccc;
            border-radius: 4px;
            color: #fff;
            border: 1px solid #ccc;

          }
          .warning4{
            text-align: center;
            color:red;
            line-height: 60px;
            height: 60px;
          }
          .button{
            width: 470px;
            height: 56px;
            background: #3D90F6;
            border-radius: 28px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 56px;
            text-align: center;
            color:#fff;
            cursor: pointer;
            margin-top: 20px;
          }
          .btn_disabled{
            width: 470px;
            height: 56px;
            background: #ccc;
            border-radius: 28px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 56px;
            text-align: center;
            color:#999;
            cursor: pointer;
            margin-top: 20px;
          }
          .bottom{
            text-align: center;
            font-size: 14px;
            line-height: 60px;
            span{
              color:#3D90F6;
              cursor: pointer;
            }
          }
        }
      }
    }
</style>
